import "./GridRow.scss";
import { ReactNode } from "react";
import { createSpreadableBem } from "/Helpers/createBem";

export enum RowSpacing {
  none = "none",
  xxl = "xxl",
  xl = "xl",
  xs = "xs",
  s = "s",
  m = "m",
  l = "l",
  textCards = "text-cards",
  eventItemCards = "event-item-cards",
  buttonGroupBlock = "button-group-block",
}

interface GridRowProps {
  children: ReactNode | ReactNode[];
  rowSpacing?: RowSpacing;
  rowSpacingMobileUp?: "xxl" | "l";
  rowSpacingTabletUp?: "xl";
  templateRows?: string[];
  noMarginsMobile?: boolean;
  noMarginsTablet?: boolean;
}

/**
 * This component will be the parent component of GridCell or GridPreset components.
 */
const GridRow = ({
  children,
  rowSpacingMobileUp,
  rowSpacingTabletUp,
  rowSpacing,
  templateRows,
  noMarginsMobile,
  noMarginsTablet,
}: GridRowProps) => {
  const bem = createSpreadableBem("grid-row");
  return (
    <div
      {...bem("", {
        "--row-spacing-mobile-up-xxl": rowSpacingMobileUp === RowSpacing.xxl,
        "--row-spacing-mobile-up-l": rowSpacingMobileUp === RowSpacing.l,
        "--row-spacing-tablet-up-xl": rowSpacingTabletUp === RowSpacing.xl,
        "--row-spacing-xxl": rowSpacing === RowSpacing.xxl,
        "--row-spacing-xl": rowSpacing === RowSpacing.xl,
        "--row-spacing-xs": rowSpacing === RowSpacing.xs,
        "--row-spacing-s": rowSpacing === RowSpacing.s,
        "--row-spacing-m": rowSpacing === RowSpacing.m,
        "--row-spacing-l": rowSpacing === RowSpacing.l,
        "--row-spacing-button-group-block":
          rowSpacing === RowSpacing.buttonGroupBlock,
        "--row-spacing-text-cards": rowSpacing === RowSpacing.textCards,
        "--row-spacing-event-item-cards":
          rowSpacing === RowSpacing.eventItemCards,
        "--no-margins-mobile": noMarginsMobile,
        "--no-margins-tablet": noMarginsTablet,
      })}
      style={{
        gridTemplateRows: templateRows ? templateRows.join(" ") : undefined,
      }}
    >
      {children}
    </div>
  );
};

export default GridRow;
